import {
  Button as ButtonBase,
  Collapse,
  ControlGroup,
  HTMLTable,
  Tag,
} from '@blueprintjs/core';
import { Users } from '@just-in-types';
import { format } from 'date-fns';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import ActiveCheckIn, { ActiveCheckInProps } from '.';
import { IState } from '../../../store';
import { isTimestamp } from '../helpers';
import { CouponGroups } from './Coupons';

interface OwnProps {
  activeBusinessId: ActiveCheckInProps['businessId'];
  activeSiteId: ActiveCheckInProps['siteId'];
  coupon: Users.Coupon;
  listTitle: string;
  redeeming: boolean;
  redeemCoupon: ActiveCheckIn['redeemCoupon'];
}

interface StateProps {
  businessNames: IState['businesses']['businessNames'];
}

type Props = OwnProps & StateProps;

interface State {
  isOpen: boolean;
}

const CouponWrapper = styled('div')`
  margin-bottom: 5px;
`;

const Button = styled(ButtonBase)`
  max-width: 7rem;
  min-width: 7rem;
`;

const TdRow = styled('td')`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    margin-right: 1rem;
  }
`;

const mapStateToProps = ({ businesses: { businessNames } }: IState) => ({
  businessNames,
});

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(
  class Coupon extends React.PureComponent<Props, State> {
    public state: State = {
      isOpen: false,
    };

    public render() {
      const {
        activeBusinessId,
        businessNames,
        coupon,
        listTitle,
        redeemCoupon,
        redeeming,
      } = this.props;
      const { isOpen } = this.state;

      const isActiveCoupon = listTitle === CouponGroups.ACTIVE;
      const fromActiveBusiness = coupon.businessId
        ? coupon.businessId === activeBusinessId
        : false;

      const disabled = !isActiveCoupon || !fromActiveBusiness;
      const expires =
        coupon.expires_date && isTimestamp(coupon.expires_date)
          ? format(coupon.expires_date.toDate(), 'M/D/YY')
          : 'n/a';

      const activeBusinessName = activeBusinessId
        ? businessNames[activeBusinessId]
        : 'n/a';
      const businessName = coupon.businessId
        ? businessNames[coupon.businessId]
        : 'n/a';
      return (
        <CouponWrapper>
          <span id="redeem-style">
          <ControlGroup fill={true}>
            <Tag
              icon={isOpen ? 'chevron-up' : 'chevron-down'}
              interactive={true}
              large={true}
              minimal={true}
              onClick={this.toggleOpen}>
              {coupon.coupon_name}
            </Tag>
            <Button
              data-coupon-id={coupon.couponId}
              disabled={disabled}
              intent={fromActiveBusiness ? 'success' : 'danger'}
              loading={redeeming}
              onClick={redeemCoupon}>
              Redeem
            </Button>
          </ControlGroup>
          </span>
          <Collapse isOpen={isOpen}>
            <HTMLTable>
              <tbody>
                <tr>
                  <td>Description:</td>
                  <td>{coupon.coupon_description}</td>
                </tr>
                <tr>
                  <td>Expires:</td>
                  <td>{expires}</td>
                </tr>
                <tr>
                  <td>Business:</td>
                  <TdRow>
                    <span>{businessName}</span>
                    {!fromActiveBusiness && (
                      <Tag icon="issue" intent="danger">
                        Not from {activeBusinessName}
                      </Tag>
                    )}
                  </TdRow>
                </tr>
              </tbody>
            </HTMLTable>
          </Collapse>
        </CouponWrapper>
      );
    }

    private toggleOpen = () =>
      this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  },
);



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/Coupon.tsx